import React, { useRef } from "react";
import { FaTimes, FaDownload } from "react-icons/fa";
import { useReactToPrint } from "react-to-print";
import Receipt from "./Receipt";
import "../styles/receiptpreviewmodal.css";

const ReceiptPreviewModal = ({ isOpen, onClose, order }) => {
  const receiptRef = useRef();

  // Handle receipt download/print
  const handlePrint = useReactToPrint({
    contentRef: receiptRef,
    documentTitle: `Receipt_${order?.order_id || "Order"}`,
    pageStyle: `
      @page {
        size: A4;
        margin: 20mm;
      }
      @media print {
        body {
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
        }
      }
    `,
  });

  if (!isOpen || !order) return null;

  return (
    <div className="receipt-preview-modal-overlay" onClick={onClose}>
      <div
        className="receipt-preview-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="receipt-preview-modal-header">
          <h2>Receipt Preview</h2>
          <button className="receipt-preview-close-btn" onClick={onClose}>
            <FaTimes />
          </button>
        </div>

        <div className="receipt-preview-modal-content">
          <div className="receipt-preview-wrapper" ref={receiptRef}>
            <Receipt order={order} />
          </div>
        </div>

        <div className="receipt-preview-modal-footer">
          <button
            className="receipt-preview-download-btn"
            onClick={handlePrint}
          >
            <FaDownload /> Download / Print Receipt
          </button>
          <button
            className="receipt-preview-close-button"
            onClick={onClose}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReceiptPreviewModal;

